/* LINEA MOVELARIA — utilitario unico de movimento.
   So opacity/transform/clip-path. Nunca CLS. Idempotente no editor. */
(function () {
  'use strict';

  var RAIZ = document.documentElement;

  function movimentoPermitido() {
    if (RAIZ.hasAttribute('data-lm-sem-motion')) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    var c = navigator.connection;
    if (c && c.saveData) return false;
    return true;
  }

  if (movimentoPermitido()) RAIZ.classList.add('lm-motion');

  var observador = null;
  var observados = new WeakSet();

  function pegarObservador() {
    if (observador) return observador;
    observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('lm-visivel');
        observador.unobserve(entrada.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    return observador;
  }

  /* Marca automaticamente o que sempre deve revelar, sem repetir o atributo
     em toda secao: o cabecalho de cada secao (sobrelinha + titulo).
     Se ja estiver na tela quando a pagina abre, entra visivel — nada pisca. */
  function marcarAutomaticos(escopo) {
    var raiz = escopo || document;
    raiz.querySelectorAll('.lm-secao .lm-cabecalho-secao').forEach(function (el) {
      if (el.hasAttribute('data-lm-revelar')) return;
      var caixa = el.getBoundingClientRect();
      var jaNaTela = caixa.top < window.innerHeight && caixa.bottom > 0;
      el.setAttribute('data-lm-revelar', '');
      if (jaNaTela) el.classList.add('lm-visivel');
    });
  }

  function revelar(escopo) {
    var raiz = escopo || document;

    if (!movimentoPermitido()) {
      raiz.querySelectorAll('[data-lm-revelar], [data-lm-mascara]').forEach(function (el) {
        el.classList.add('lm-visivel');
      });
      return;
    }

    var obs = pegarObservador();
    var grupos = {};

    raiz.querySelectorAll('[data-lm-revelar], [data-lm-mascara]').forEach(function (el) {
      if (observados.has(el)) return;
      observados.add(el);

      var grupo = el.getAttribute('data-lm-grupo') || '_';
      grupos[grupo] = grupos[grupo] || 0;
      var indice = grupos[grupo]++;

      var passo = Math.min(indice, 5);
      if (passo > 0) el.style.setProperty('--lm-atraso', passo * 80 + 'ms');

      obs.observe(el);
    });
  }

  var obsPausa = null;

  function pausarForaDaTela(escopo) {
    if (!movimentoPermitido()) return;
    var raiz = escopo || document;

    if (!obsPausa) {
      obsPausa = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          e.target.classList.toggle('lm-pausado', !e.isIntersecting);
        });
      }, { threshold: 0 });
    }

    raiz.querySelectorAll('[data-lm-kenburns]').forEach(function (el) {
      obsPausa.observe(el);
    });
  }

  function iniciar(escopo) {
    if (movimentoPermitido()) marcarAutomaticos(escopo);
    revelar(escopo);
    pausarForaDaTela(escopo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); }, { once: true });
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!observador && !obsPausa) return;
    e.target.querySelectorAll('[data-lm-revelar], [data-lm-mascara]').forEach(function (el) {
      if (observador) observador.unobserve(el);
      observados.delete(el);
    });
    e.target.querySelectorAll('[data-lm-kenburns]').forEach(function (el) {
      if (obsPausa) obsPausa.unobserve(el);
    });
  });

  window.lmMotion = { iniciar: iniciar, permitido: movimentoPermitido };
})();
